<div class="form-control form-control-{{size}} clickable" (click)="modal.show()">
  @if (!timeSelectable && date) {
    <span>{{ date | date : 'dd.MM.yyyy' }}</span>
  }
  @if (timeSelectable && date) {
    <span>{{ date | date : 'dd.MM.yyyy' }} um {{ date | date : 'HH.mm' }} Uhr</span>
  }
  @if (!date) {
    <span class="text-muted">Kein Datum gewählt</span>
  }
</div>

<sc-modal #modal>
  <sc-modal-header>
    Bearbeiten
  </sc-modal-header>

  <sc-modal-body>
    <div class="row">
      <div class="col-12 col-lg-6">
        <sc-date-picker [date]="date" (dateChange)="setDate($event)" displayMonths="1" #d></sc-date-picker>
      </div>
      <div class="col-12 col-lg-6">
        @if (timeSelectable) {
          <div class="row align-items-center mt-3 mt-lg-0">
            <div class="col-2">
              @if (rangeSelectable) {
                <span>Von</span>
              }
              @if (!rangeSelectable) {
                <span>Um</span>
              }
            </div>
            <div class="col-4">
              <div ngbDropdown>
                <div ngbDropdownToggle>
                  <div class="form-control">
                    {{ date | date : 'HH' }}
                  </div>
                </div>
                <div ngbDropdownMenu>
                  @for (h of hours; track h) {
                    <a class="dropdown-item" (click)="setStartHours(h)">
                      {{ h | number : '2.0' }}
                    </a>
                  }
                </div>
              </div>
            </div>
            <div class="col-auto px-0">
              :
            </div>
            <div class="col-4">
              <div ngbDropdown>
                <div ngbDropdownToggle>
                  <div class="form-control">
                    {{ date | date : 'mm' }}
                  </div>
                </div>
                <div ngbDropdownMenu>
                  @for (m of minutes; track m) {
                    <a class="dropdown-item" (click)="setStartMinutes(m)">
                      {{ m | number : '2.0' }}
                    </a>
                  }
                </div>
              </div>
            </div>
          </div>
        }

        @if (rangeSelectable && timeSelectable) {
          <div class="row align-items-center mt-3 mt-lg-0">
            <div class="col-2">
              Bis
            </div>
            <div class="col-4">
              <div ngbDropdown>
                <div ngbDropdownToggle>
                  <div class="form-control">
                    {{ end | date : 'HH' }}
                  </div>
                </div>
                <div ngbDropdownMenu>
                  @for (h of hours; track h) {
                    <a class="dropdown-item" (click)="setEndHours(h)">
                      {{ h | number : '2.0' }}
                    </a>
                  }
                </div>
              </div>
            </div>
            <div class="col-auto px-0">
              :
            </div>
            <div class="col-4">
              <div ngbDropdown>
                <div ngbDropdownToggle>
                  <div class="form-control">
                    {{ end | date : 'mm' }}
                  </div>
                </div>
                <div ngbDropdownMenu>
                  @for (m of minutes; track m) {
                    <a class="dropdown-item" (click)="setEndMinutes(h)">
                      {{ m | number : '2.0' }}
                    </a>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

  </sc-modal-body>

  <sc-modal-footer>
    <button class="btn btn-dark" (click)="modal.dismiss();">Fertig</button>
  </sc-modal-footer>
</sc-modal>
